import Cookies from 'js-cookie'
import { getUrlKey, getHtmlParams } from '@/utils'
import { config } from '@/config/config'
import { setOptionCookie } from '@/utils/cookieOperation'
import { getDictionaryApi } from '@/api/common/public'

// import { app } from '@/api/common/app'
import { getSmsNoticeChannel } from '@/api/common/public'
import { isString } from 'lodash-es'

// import { app } from '@/api/common/app'

// import { getLanguage } from '@/lang/index'
// import { thirdPartyQrcode } from '../../api/common/user'

// function getThirdPartyQrcode() {
//   try {
//     return localStorage['THIRD_PARTY_QRCODE'] ? JSON.parse(localStorage['THIRD_PARTY_QRCODE']) : []
//   } catch (e) {
//     return []
//   }
// }

const state = {
  sidebar: {
    opened: true,
    withoutAnimation: false
  },
  uiConfig: {
    ...config
  },
  cookie_terms: {
    title: '',
    show: false,
    type: ''
  },
  device: 'desktop',
  cookie_agree: Cookies.get('option.preference') ? JSON.parse(Cookies.get('option.preference')) : {
    agree: false,
    optimisation: false,
    analytics: false,
    id: ''
  },
  system_source: getUrlKey('sysCode') || '', // url上源系统编码
  source: getUrlKey('source') || '', // url上源系统渠道来源（sfbuy用）
  email: getUrlKey('email') ? decodeURIComponent(getUrlKey('email')) : '', // url上源系统的email（sfbuy用）
  inexRequestId: getUrlKey('requestId') || '',
  thirdPartyQrcode: [],
  // sysCodeWhiteList: ['IUOP'],
  loading: false,
  sendSmsTypes: [{
    value: 'sms',
    label: 'sms'
  }],
  sendSmsTypesDic: {},
  // showSmsDialog: false,
  commonUrlParams: {},
  defaultCookieId: '',
  isVerficationCodeFirst: 'ready', // ready 未拉到状态，on 开启验证码登录优先模式 off 关闭验证码登录优先模式
}

const mutations = {
  TOGGLE_SIDEBAR: state => {
    state.sidebar.opened = !state.sidebar.opened
    state.sidebar.withoutAnimation = false
    if (state.sidebar.opened) {
      Cookies.set('sidebarStatus', 1)
    } else {
      Cookies.set('sidebarStatus', 0)
    }
  },
  SET_SMS_NOTICE_CHANNEL: (state, data) => {
    state.sendSmsTypes = data
  },
  SET_SMS_NOTICE_CHANNEL_DIC: (state, data) => {
    state.sendSmsTypesDic = data
  },
  // SET_SMS_NOTICE_CHANNEL_DIALOG: (state, show) => {
  //   state.showSmsDialog = show
  // },
  CLOSE_SIDEBAR: (state, withoutAnimation) => {
    Cookies.set('sidebarStatus', 0)
    state.sidebar.opened = false
    state.sidebar.withoutAnimation = withoutAnimation
  },
  OPEN_SIDEBAR: (state, withoutAnimation) => {
    Cookies.set('sidebarStatus', 1)
    state.sidebar.opened = true
    state.sidebar.withoutAnimation = withoutAnimation
  },
  TOGGLE_DEVICE: (state, device) => {
    state.device = device
  },
  SET_AGREE_COOKIE: (state, agree) => {
    // 根据域名设置cookie政策的cookie
    setOptionCookie(agree)
    state.cookie_agree = JSON.parse(agree)
  },
  SET_COOKIE_TERMS: (state, value) => {
    state.cookie_terms = value
  },
  SET_SYSTEM_SOURCE: (state, value) => {
    state.system_source = value
  },
  SET_THIRD_PARTY_QRCODE: (state, value) => {
    // if (value.length > 0) {
    //   localStorage['THIRD_PARTY_QRCODE'] = JSON.stringify(value)
    // } else {
    state.thirdPartyQrcode = value
    // }
  },
  SET_SYSCODE_WHITE_LIST: (state, value) => {
    // if (value.length > 0) {
    //   localStorage['THIRD_PARTY_QRCODE'] = JSON.stringify(value)
    // } else {
    state.sysCodeWhiteList = value
    // }
  },

  SET_LOADING: (state, value) => {
    state.loading = value
  },
  SET_UI_CONFIG: (state, config) => {
    state.uiConfig = config
  },
  SET_COMMON_URL_PARAMS: (state, value) => {
    state.commonUrlParams = value || {}
  },
  SET_VERIFICATION_CODE: (state, value) => {
    state.isVerficationCodeFirst = value
  },
  setDefaultCookieId: (state, id) => {
    state.defaultCookieId = id
  }
}

const actions = {
  async getVerficationCodeStatue({ commit }, countryCode) {
    const response = await getDictionaryApi({ name: 'pw_weaken', lang: 'en' })
    if (response.data && isString(response.data.country)) {
      commit('SET_VERIFICATION_CODE', response.data.country.split(',').indexOf(countryCode) > -1 ? 'on' : 'off')
    } else {
      commit('SET_VERIFICATION_CODE', 'off')
    }
  },
  /**
   * 获取短信通知渠道下拉列表
   * @param {*} param0
   * @param {*} userInfo
   */
  async getSmsNoticeChannel({ rootState, commit, dispatch }, payload) {
    const { phoneCode, noStore, countryCode } = payload || {}
    if (countryCode || rootState.site.siteCode) {
      const res = await getSmsNoticeChannel({ 'country': countryCode || rootState.site.siteCode, phoneCode })
      if (res.code === '0') {
        const datas = []
        const resCountryCode = res.data
        let resText = {}

        if (!Object.keys(rootState.app.sendSmsTypesDic).length) {
          const rs = await getDictionaryApi({ name: 'noticeChannelDesc' }, { customedHeaderLang: rootState.site.language })
          resText = rs.data
          commit('SET_SMS_NOTICE_CHANNEL_DIC', resText)
        } else {
          resText = rootState.app.sendSmsTypesDic
        }
        resCountryCode.forEach(item => {
          const data = {
            value: item,
            label: resText[item]
          }
          datas.push(data)
        })
        if (!noStore) {
          commit('SET_SMS_NOTICE_CHANNEL', datas)
        }
        // if (datas.length > 1) {
        //   commit('SET_SMS_NOTICE_CHANNEL_DIALOG', true)
        // }
        return datas
      }
    }
  },
  setSmsTypeDic({ commit }, data) {
    commit('SET_SMS_NOTICE_CHANNEL_DIC', data)
  },
  toggleSideBar({ commit }) {
    commit('TOGGLE_SIDEBAR')
  },
  setThirdPartyQrcode({ commit }, { datas }) {
    commit('SET_THIRD_PARTY_QRCODE', datas)
  },
  async setSysCodeWhiteList({ commit }, { datas }) {
    // const response = await getDictionaryApi({ name: 'login_syscode_whitelist', key: 'login', lang: 'zh-CN' })
    // let list = []
    // try {
    //   list = JSON.parse(response.data.login)
    // } catch (e) {
    //   console.log(e)
    // }
    // // datas = ['IUOP']
    // commit('SET_SYSCODE_WHITE_LIST', list)
  },
  closeSideBar({ commit }, { withoutAnimation }) {
    commit('CLOSE_SIDEBAR', withoutAnimation)
  },
  openSideBar({ commit }, { withoutAnimation }) {
    commit('OPEN_SIDEBAR', withoutAnimation)
  },
  toggleDevice({ commit }, device) {
    commit('TOGGLE_DEVICE', device)
  },
  setAgreeCookie({ commit }, agree) {
    commit('SET_AGREE_COOKIE', agree)
  },
  setUIConfig({ commit }, config) {
    commit('SET_UI_CONFIG', config)
  },
  setAppLoading({ commit }, loading) {
    commit('SET_LOADING', loading)
  },

  setCommonUrlParams({ commit }, keys) {
    // 获取url 参数中 key 在 keys 中的值
    const urlObj = getHtmlParams()
    const result = {}
    keys.forEach(key => {
      if (urlObj[key] !== undefined) {
        if (key === 'referrerCode') {
          try {
            result[key] = decodeURIComponent(urlObj[key])
          } catch (error) {
            result[key] = urlObj[key]
          }
        } else {
          result[key] = urlObj[key]
        }
      }
    })
    commit('SET_COMMON_URL_PARAMS', result)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
